module.exports = {
    label: {
        date: 'Date',
        scriptId: 'Script ID',
        header: 'Script Request Details',
        appointmentHeader: 'Script Details',
        rejectHeader: 'Reject Group Request Details',
        patientName: 'Name of Patient',
        gender: 'Gender',
        dob: 'DOB',
        bloodGroup: 'Blood Group',
        phoneNumber: 'Phone Number',
        address: 'Address',
        namePharmacist: 'Name of Pharmacist',
        email: 'Email',
        status: 'Status',
        paidBy: 'Paid by',
        totalPrice: 'Total Price of Script',
        adminCommissionPercentage: 'Admin’s Commission Percentage',
        adminCommissionAmount: 'Admin’s Commission Amount',
        myAmount: 'My Amount',
        nodata: '----',
        copiedlink: 'Link copied Successfully!!',
        errorIncopyLink: 'Failed to copy link',
        idNumber: 'ID Number',
        patientMinor: 'Is Patient a Minor?',
        parentName: 'Name of Parent/Guardian',
        parentIDNumber: 'ID No. of Patient or Guardian',
//        medicineRequired: 'Medicine required',
        medicineRequired: 'Medicine requested by patient via request form',
        specialInstructions: 'Special instructions/other',
        error: 'Something Went Wrong',
        prescription: 'Prescription',
        rejectRequest: 'Reject Request',
        reason: 'Reason',
        enterReason: 'Enter Reason',
        requestRejected: 'Group Request Rejected',
        height: 'Height',
        weight: 'Weight',
        bmi: 'BMI',
        pulse: 'Pulse',
        glucose: 'Glucose',
        smoker: 'Smoker',
        riskFactors: 'Risk Factors',
        bloodPressure: 'Blood Pressure',
        medication: 'Medication',
        nursingPractitioner: 'Nursing practitioner',
        clinicEmail: 'Clinic email',
        notes: 'Notes',
        medication_needed: 'Cannabis product needed - dose and frequency - If you are a new user please indicate it here / Notes',
        height: 'Height',
        weight: 'Weight',
        bmi: 'BMI',
        note: 'Note',
        nurseNote: 'Notes to patient',
        noteRequired: 'Please enter note',
        reasonRequired: 'Please enter reason',
        enterNote: 'Enter Note',
        rejectReason: 'Reject Reason',
        scriptRequestStatus: 'Script Request Status',
        placeholder: {
            enterName: 'Enter Name',
        },
        no:'No',
        yes:'Yes',
        nameOfParent:'Name of parent / Guardian',
        idOfParent:'ID no of parent or guardian',
        specialInstruction:'Special instructions / other',
        namePharmacy:'Name of pharmacy',
        emailPharmacy:'E-mail address of pharmacy',
        mobilePharmacy:'Mobile of pharmacy',
        buttons: {
            copyScript: 'Copy Script Link',
            copyEScript: 'Copy eScript Link',
            shareScript: 'Share Script Via Email',
            shareEScript: 'Share eScript Via Email',
            reject: 'Reject',
            submit: 'Submit',
            sendNote: 'Send a note to patient',
            createScriptModal: 'Create Script',
            createScript: "Create script / document",
            createEScript: "Create e-script / e-document"
        }
    }
};
